import React from "react";
import {connect} from "react-redux";
import Modal from "react-bootstrap/Modal";


const stateMap = (store) => {
    return {
        i18n: store.i18n,
        userReducer: store.userReducer
    };
};

class GenericModal extends React.Component {
    // Map Bootstrap 3 bsSize to Bootstrap 5 size
    mapSize(bsSize) {
        if (bsSize === 'large') return 'lg';
        if (bsSize === 'small') return 'sm';
        return undefined;
    }
    
    render() {
        return (
            <Modal show={this.props.showModal}
                   onHide={this.props.onHide}
                   size={this.mapSize(this.props.bsSize)}
                   className={this.props.modalClass ? this.props.modalClass : ''}
                   dialogClassName={this.props.dialogClassName ? this.props.dialogClassName : ''}>
                <Modal.Header className={this.props.modalHeaderClass ? this.props.modalHeaderClass : ''}
                             closeButton={this.props.showCloseButton}>
                    {this.props.modalTitle ?
                        <Modal.Title>
                            {this.props.modalTitle}
                        </Modal.Title> : null}
                </Modal.Header>
                <Modal.Body className={this.props.modalBodyClass ? this.props.modalBodyClass : ''}>
                    {this.props.modalBody}
                </Modal.Body>
                {this.props.modalFooter ?
                    <Modal.Footer className={this.props.modalFooterClass ? this.props.modalFooterClass : ''}>
                        {this.props.modalFooter}
                    </Modal.Footer> : null}
            </Modal>
        )
    }
}

export default connect(stateMap)(GenericModal);
